import { connect } from 'react-redux';
import { PillBarCarousel } from '@noths/polaris-client-ribbons-design-system';

import { carouselVisible, clickCarouselLink, navigateCarousel } from '../modules/actions';

export const mapDispatchToProps = {
  onLinkClick: clickCarouselLink,
  onNavigateCarousel: navigateCarousel,
  onCarouselVisible: carouselVisible,
};

export const LinkCarouselContainer = connect(null, mapDispatchToProps)(PillBarCarousel);
